/**
 * Valeurs d'affichage manquantes / legacy (données ou anciennes traductions EN).
 */
const LEGACY_MISSING_DISPLAY = new Set([
  '',
  'N/A',
  'Unknown',
  'Unknown Product',
  'Unknown Worker',
  'Unknown Customer'
]);

/** Indique si une valeur doit être remplacée par un libellé i18n. */
export function isMissingDisplayValue(value) {
  const normalized = String(value ?? '').trim();
  return LEGACY_MISSING_DISPLAY.has(normalized);
}

/** Retourne la valeur ou le fallback i18n si manquante / legacy. */
export function resolveDisplayValue(value, fallback) {
  return isMissingDisplayValue(value) ? fallback : String(value).trim();
}
